import React from 'react';
import PropTypes from 'prop-types';

import { Plans } from '../../constants';
import { annualPerks, seasonalPerks } from './constants';
import Tooltip from '../Tooltip';
import styles from './plan-list.module.scss';

const PlanList = ({ selectedPlan }) => {
  const currentList = selectedPlan === Plans.ANNUAL
    ? annualPerks : seasonalPerks;
  return (
    <section className={styles['plan-perks']}>
      <ul className={styles['plan-perks__list']}>
        {currentList.map(({ label, info }) => (
          <li key={label} className={styles['plan-perks__item']}>
            <i
              className="fas fa-check"
              style={{
                fontSize: '18px',
                fontWeight: '400',
                color: '#9dd321',
                margin: '0 12px 0 0',
                cursor: 'unset',
              }}
            />
            <span>{label}</span>
            {info && (<Tooltip message={info}><i className="fas fa-info-circle" /></Tooltip>)}
          </li>
        ))}
      </ul>
    </section>
  );
};

PlanList.defaultProps = {
  selectedPlan: Plans.ANNUAL,
};

PlanList.propTypes = {
  selectedPlan: PropTypes.string,
};

export default PlanList;
